// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__f6uhK","newExpiryDate":"styles_newExpiryDate__35VHP","footer":"styles_footer__4uIOd"};